import { ElMessage } from "element-plus";
import { ApiError } from "./request";

/** 直下接口若实际返回 JSON 错误信封，转为 ApiError 并提示。 */
export async function unwrapDownloadBlob(blob: Blob): Promise<Blob> {
    if (!blob.type.includes("json")) {
        return blob;
    }
    const text = await blob.text();
    try {
        const json = JSON.parse(text) as { code?: number; message?: string; data?: unknown };
        if (typeof json.code !== "undefined" && Number(json.code) !== 0) {
            const message = String(json.message ?? "").trim();
            if (message) {
                ElMessage.error(message);
            }
            throw new ApiError(Number(json.code), message, json.data);
        }
    } catch (error) {
        if (error instanceof ApiError) {
            throw error;
        }
    }
    return new Blob([text], { type: blob.type });
}

/** 将接口返回的 Blob 触发浏览器本地下载，不进入下载中心。 */
export function triggerBlobDownload(blob: Blob, fileName: string): void {
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    link.rel = "noopener";
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
}
